import React from 'react'

export const RepostIcon = ({
  fill = 'none',
  width = '20',
  height = '20',
  stroke = '#000000',
  strokeGradient = [],
  viewBox = '0 0 24 24'
}) => (
  <svg
    fill={fill}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    cursor="pointer"
    style={{
      rotate: '87.5deg',
      transform: 'scaleY(-1)'
    }}
  >
    {
      strokeGradient.length
        ? (
          <defs>
            <linearGradient
              id="gradient"
              x1="60%"
              x2="40%"
              y1="40%"
              y2="60%"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset="0%"
                stopColor={strokeGradient[1]}
              />
              <stop
                offset="100%"
                stopColor={strokeGradient[0]}
              />
            </linearGradient>
          </defs>
        ) : ''
    }

    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <path
        d="M6,14V9A6,6,0,0,1,16.89,5.54"
        style={{
          fill,
          stroke: stroke === 'gradient' ? 'url(#gradient)' : stroke,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 2
        }}
      />
      <path
        d="M18,10v5A6,6,0,0,1,7.11,18.46"
        style={{
          fill,
          stroke: stroke === 'gradient' ? 'url(#gradient)' : stroke,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 2
        }}
      />
      <polyline
        points="8 12 6 14 4 12"
        style={{
          fill,
          stroke: stroke === 'gradient' ? 'url(#gradient)' : stroke,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 2
        }}
      />
      <polyline
        points="16 12 18 10 20 12"
        style={{
          fill,
          stroke: stroke === 'gradient' ? 'url(#gradient)' : stroke,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 2
        }}
      />
    </g>
  </svg>
)
